<input type="text" #inputText
  [style.width.px]="width" [style.width]="width !== undefined ? width : '3rem'"
  [class.text-label-required]="required" [disabled]="disabled"
  [style.font-size]="fontSize" [readonly]="!editable" [maxLength]="maxChars" plessInputTextSub [restrict]="restrict"
  [tabindex]="tabEnabled ? tabindex : -1" [(ngModel)]="text" [halfOnly]="true"
  [autofocus]="autofocus" (ngModelChange)="changeMarkCodeHandler();onChange($event);"
  (blur)="onTouched();blurHandler($event)" />
